export default "__VITE_ASSET__N7QjA3CL__"